import cn from 'classnames'
import { CSSProperties } from 'react'

import type { ChipProps } from './types'

import './styles.scss'

const Chip = ({ className, background, ...rest }: ChipProps) => {
  return (
    <span
      {...rest}
      className={cn('chip', className)}
      style={{ '--chip-background': background } as CSSProperties}
    />
  )
}

export default Chip
